<template>
	<div  class="tabWrapper wrapUserTabStatements">
		<div class="main">
			<no-info
					v-if="userLogs && userLogs.length <= 0"
					text="This user has no changes yet, so the logs are empty."
			/>
			<main-table
					v-else
					:is-create="false"
					padding="10px"
					page-title="User update logs"
					flag="UserUpdateLogs"
					:headers="getHeaders"
					:listItems="userLogs"
					:filtersList="userLogsFilter"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
					@updateSearch="onFilter"
					@updateRefreshFilters="onFilter"
					@updateChangeSort="onFilter"
					:is-export="false"
					:is-settings="false"
			></main-table>
		</div>
	</div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { logsHeader } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";
import NoInfo from "@/shared/NoInfo/NoInfo";

export default {
	name: "UserTabLogs",
	components: { NoInfo },
	computed: {
		...mapGetters([
			"userLogs",
			"userLogsFilter",
		]),

		getHeaders() {
			return logsHeader;
		}
	},
	props: {
		user: Object,
	},
	data() {
		return {
			flag: "userUpdateLogs",
			id: null,
		};
	},
	methods: {
		...mapActions([
			"getUserLogs",
		]),
		async onFilter(info) {
			const { dispatcher_id } = this.user;

			const payload = {
				dispatcher_id,
				...info.filterModList
			};

			await this.getUserLogs(payload);
		}
	},
	//
	async mounted() {
		const {
			dispatcher_id,
		} = this.user;
		this.id = dispatcher_id;

		await this.getUserLogs({ dispatcher_id });
	}
};
</script>

<style scoped>

</style>
